import { render, staticRenderFns } from "./Boderne.vue?vue&type=template&id=f8bc2cee&"
import script from "./Boderne.vue?vue&type=script&lang=js&"
export * from "./Boderne.vue?vue&type=script&lang=js&"
import style0 from "./Boderne.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports